import { DateTime } from "luxon";

export const setServerTime = (req, res, ctx) => {
    const response = {
        currentTime: DateTime.local()
    };

    return res(ctx.status(201), ctx.json(response));
};
